import React from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import { withNamespaces, Trans } from 'react-i18next';

import { Link } from 'core/routing';
import { media, truncateWidth } from 'legacyComponents/styled/styleUtils';
import { customMedia } from 'styles/utils';

import { clientStore } from 'apps/client/app';

import { RepoColumn, RepoColumnText } from 'apps/repository/styles';

export const Message = withNamespaces()(
  ({ fileInfo = {}, message = '', isTitle = false, project }) => {
    if (!isTitle) {
      const { reference } = fileInfo;
      if (reference) {
        if (reference.opType) {
          // operation
          if (reference.isFolder) {
            // folder
            if (!reference.hasContent) {
              // empty folder
              message = (
                <Trans>
                  ☝ Note: Empty folders will be removed during the contribution
                  process.
                </Trans>
              );
            }
          } else {
            // not a folder
            message = reference.file.sizeStr;
          }
        } else {
          // not an operation
          const contribRoute = `${clientStore.spaceRoute.route}.contribution`;
          const shortContributionId = reference.origin.version.substring(0, 7);
          const params = Object.assign({}, clientStore.spaceParams, {
            contributionId: shortContributionId,
          });
          message = (
            <div>
              <ContribPageLink
                name={contribRoute}
                params={params}
                content={project.content}
                draggable={false}
              >
                {reference.origin.title ||
                  `Contribution #${shortContributionId}`}
              </ContribPageLink>
              <Version> (#{shortContributionId})</Version>
            </div>
          );
        }
      }
    }
    return (
      <Column slim={isTitle} isFlex>
        <Text isTitle={isTitle} truncate='message'>
          {message}
        </Text>
      </Column>
    );
  },
);

const Column = styled(RepoColumn)`
  width: 540px;
  ${customMedia.greaterThan('xlarge')`
    width: 474px;
  `}
  ${media.l`
    width: 455px;
  `}
  ${media.m`
    display: none;
  `}
`;

const Text = styled(RepoColumnText)`
  font-size: ${props => (props.isTitle ? '0.75em' : '0.915em')};
  ${truncateWidth('535px')}
  ${media.l`
    ${truncateWidth('465px')}
  `}
`;

const Version = styled.span`
  color: ${props => props.theme.color.wfGrey500};
  &:hover {
    text-decoration: none !important;
  }
`;

const ContribPageLink = styled(Link)`
  text-decoration: none;
  color: ${props => props.theme.color.wfGrey900};
  &:hover {
    text-decoration: underline;
    color: ${props => props.theme.color.primary};
  }
`;

Message.propTypes = {
  message: PropTypes.string,
  rowHeader: PropTypes.bool,
};
